import { Link } from "react-router-dom";
import { ROUTES } from "@/domain/constants/routes";

export function HeroSection() {
  return (
    <section className="pt-20 pb-16 bg-cream local-pattern">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-8">
          <div className="inline-flex items-center space-x-2 bg-warm-beige border border-tea-brown/20 px-4 py-2 rounded-full text-sm">
            <i className="fas fa-leaf text-earth-green"></i>
            <a
              href="https://corp.mediatek.tw/geniusforhome"
              className="text-tea-brown"
            >
              MediaTek 智在家鄉 2025 計畫
            </a>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="mb-6">
              <img
                src="/assets/images/logo.jpg"
                alt="麻薏 Mayi AI Logo"
                className="w-20 h-20 mx-auto mb-4 bg-warm-beige p-2 rounded-2xl warm-shadow"
              />
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-earth-green mb-6 handwriting text-shadow">
              麻薏 Mayi AI
            </h1>

            <p className="text-xl sm:text-2xl text-tea-brown mb-4 font-medium">
              來自台中的智慧營運助理
            </p>

            <div className="bg-warm-beige rounded-2xl p-6 mb-8 warm-shadow">
              <p className="text-lg text-clay-brown leading-relaxed handwriting">
                「麻薏」是黃麻嫩葉，台中人夏日必喝的消暑湯品。
                <br className="hidden sm:block" />
                就像阿嬤用心熬煮的麻薏湯，我們用在地的溫度與智慧，
                <br className="hidden sm:block" />
                陪伴每一家中小企業，慢慢走向數位轉型。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <Link
                to={ROUTES.LOGIN}
                className="inline-flex items-center justify-center px-8 py-4 bg-earth-green text-cream rounded-full font-semibold hover:bg-soft-green transition-colors soft-hover warm-shadow"
              >
                <i className="fas fa-heart mr-2"></i>
                立即體驗
              </Link>
              <a
                href="#features"
                className="inline-flex items-center justify-center px-8 py-4 bg-warm-beige text-earth-green border-2 border-earth-green rounded-full font-semibold hover:bg-earth-green hover:text-cream transition-colors"
              >
                <i className="fas fa-leaf mr-2"></i>
                了解服務
              </a>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="text-center p-4 bg-warm-beige rounded-xl warm-shadow">
                <div className="text-2xl font-bold text-earth-green handwriting mb-1">
                  在地深耕
                </div>
                <div className="text-sm text-tea-brown">台中專業服務</div>
              </div>
              <div className="text-center p-4 bg-warm-beige rounded-xl warm-shadow">
                <div className="text-2xl font-bold text-earth-green handwriting mb-1">
                  用心陪伴
                </div>
                <div className="text-sm text-tea-brown">如家人般的貼心支持</div>
              </div>
              <div className="text-center p-4 bg-warm-beige rounded-xl warm-shadow">
                <div className="text-2xl font-bold text-earth-green handwriting mb-1">
                  智慧創新
                </div>
                <div className="text-sm text-tea-brown">
                  AI 技術與在地智慧融合
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
